/**
 * Arabic for the flight record (AODB). Proposed; pending native aviation
 * review. MVT, SSIM, AIDX and ICAO designators are kept as the industry
 * writes them.
 */
const ar: Record<string, string> = {
  "Flight record": "سجل الرحلات",
  "The airport's operational database: every flight generated from the seasonal schedule (SSIM), kept current by movement messages (MVT) applied as they arrive, checked against itself, and a predicted time for every flight not yet flown — learned from its own history, corrected for how the airline's estimates turn out, held back by a late inbound unit — each with its reasons and a confidence; every change on the flight's history.":
    "قاعدة البيانات التشغيلية للمطار: كل رحلة تُنشأ من الجدول الموسمي (SSIM)، وتُحدَّث برسائل الحركة (MVT) فور وصولها، وتُفحص مقابل نفسها، ووقت متوقع لكل رحلة لم تُنفَّذ بعد — يُتعلَّم من تاريخها، ويُصحَّح بحسب دقة تقديرات شركة الطيران، ويُؤخَّر بتأخر الطائرة القادمة — ولكلٍّ أسبابه ودرجة ثقته؛ وكل تغيير في سجل الرحلة.",
  "Applied: {f}.": "طُبّقت: {f}.",
  Booked: "المحجوز",
  "Change the record": "تعديل السجل",
  "Delay codes": "رموز التأخير",
  "Fill in an example arrival": "املأ مثالاً لوصول",
  "From / to": "من / إلى",
  "Gate / stand": "البوابة / الموقف",
  "Generate the next 7 days": "إنشاء الأيام السبعة القادمة",
  "Load and delay": "الحمولة والتأخير",
  Load: "الحمولة",
  "Messages that set it": "الرسائل التي حددته",
  "Movement message": "رسالة الحركة",
  "No flights on the record for this day.": "لا رحلات في السجل لهذا اليوم.",
  "No schedule has been loaded for this day — no flights is not the same as none known.":
    "لم يُحمَّل جدول لهذا اليوم — «لا رحلات» ليست كـ«لا معلومات».",
  "Nothing has flown yet today.": "لم تُنفَّذ أي رحلة بعد اليوم.",
  "On board": "على متن الطائرة",
  Predicted: "المتوقع",
  "Reg.": "التسجيل",
  "SSIM records": "سجلات SSIM",
  "Save to the record": "حفظ في السجل",
  Season: "الموسم",
  "The airport's record of every flight — generated from the seasonal schedule, kept up to date by movement messages, checked against itself, and a predicted time for every flight not yet flown, with the reasons.":
    "سجل المطار لكل رحلة — يُنشأ من الجدول الموسمي، ويُحدَّث برسائل الحركة، ويُفحص مقابل نفسه، مع وقت متوقع لكل رحلة لم تُنفَّذ بعد وأسبابه.",
  Times: "الأوقات",
  Valid: "السريان",
  "Which flights will run late?": "أي الرحلات ستتأخر؟",
  "Why this prediction": "لماذا هذا التوقع",
  "against the schedule": "مقارنة بالجدول",
  "average delay": "متوسط التأخير",
  "contradicting the record": "تتعارض مع السجل",
  flagged: "مُعلَّمة",
  "flights today": "رحلات اليوم",
  "more than 15 min, not yet flown": "أكثر من 15 دقيقة، لم تُنفَّذ بعد",
  "on board": "على متن الطائرات",
  "predicted late": "يُتوقع تأخرها",
  "registration not yet known": "التسجيل غير معروف بعد",
  "reported by the airlines": "كما أبلغت شركات الطيران",
  "scheduled, estimated, actual and predicted — never one in place of another":
    "المجدول والمقدَّر والفعلي والمتوقع — لا يحل أحدها محل الآخر أبداً",
  "the airline's call, the handler …": "قرار شركة الطيران، المناول …",
  "version {v}": "الإصدار {v}",
  "within 15 min, of {n} flown": "خلال 15 دقيقة، من {n} منفَّذة",
  "{a} arrivals · {d} departures": "{a} وصول · {d} مغادرة",
  "{c} flights made; {k} were already on the record.": "أُنشئت {c} رحلات؛ و{k} كانت في السجل مسبقاً.",
  "{l} legs read, {n} lines added.": "قُرئت {l} مقاطع، وأُضيفت {n} سطور.",
  "{model} · {n} past flights behind it": "{model} · يستند إلى {n} رحلة سابقة",
  "{n} flights on the record today, {f} flown.": "{n} رحلات في سجل اليوم، نُفِّذت {f}.",
  "{n} predicted to run late; {f} flagged.": "{n} يُتوقع تأخرها؛ و{f} مُعلَّمة.",
  "{p}% on time so far.": "{p}% في الموعد حتى الآن.",
  arrival: "وصول",
  departure: "مغادرة",
  applied: "طُبّقت",
  held: "معلّقة",
  Confirmed: "مؤكد",
  Diverted: "حُوِّل",
  created: "أُنشئ",
  "actual at": "الوقت الفعلي",
  "estimated at": "الوقت المقدَّر",
  "predicted at": "الوقت المتوقع",
  milestones: "المراحل",
  loads: "الحمولة",
  "delay codes": "رموز التأخير",
  handling: "المناولة",
  registration: "التسجيل",
  remarks: "ملاحظات",
  mvt: "رسالة حركة",
  aidx: "تحديث منظَّم",
  manual: "يدوي",
  schedule: "الجدول",
  predictor: "المتنبئ",
  "left position": "غادر الموقف",
  arrived: "هبط",
  "reached position": "وصل الموقف",
  "Predicted to run late": "يُتوقع تأخرها",
  "not yet flown — the reasons are the prediction's own": "لم تُنفَّذ بعد — الأسباب من التوقع نفسه",
  "Seasonal schedule": "الجدول الموسمي",
  "Messages in": "الرسائل الواردة",
  "the lines each day's flights are generated from — each flight once":
    "السطور التي تُنشأ منها رحلات كل يوم — كل رحلة مرة واحدة",
  "Import an SSIM file": "استيراد ملف SSIM",
  "type-3 records; the legs touching this airport become arrival and departure lines":
    "سجلات من النوع 3؛ المقاطع التي تمس هذا المطار تصبح سطور وصول ومغادرة",
  "Apply a movement message": "تطبيق رسالة حركة",
  "MVT as the airline sends it — applied to the flight it names, or held with the reason":
    "رسالة MVT كما ترسلها شركة الطيران — تُطبَّق على الرحلة التي تسمّيها، أو تُعلَّق مع السبب",
  "every message kept as it arrived, with what it did": "كل رسالة محفوظة كما وصلت، مع ما فعلته",
  "Estimated (local HH:MM)": "المقدَّر (بالتوقيت المحلي HH:MM)",
};

export default ar;
